// Google Analytics Configuration Interface
export interface GoogleAnalyticsConfig {
  enabled: boolean;
  measurementId: string;
  config: {
    send_page_view: boolean;
    anonymize_ip: boolean;
    cookie_flags: string;
  };
  debug: boolean;
}

export interface AnalyticsConfig {
  googleAnalytics: GoogleAnalyticsConfig;
}

// Load analytics configuration from JSON file
export const loadAnalyticsConfig = async (): Promise<AnalyticsConfig | null> => {
  try {
    const response = await fetch('/config/analytics.json');
    if (!response.ok) {
      console.warn('Analytics config file not found, analytics disabled');
      return null;
    }
    const config = await response.json();
    return config;
  } catch (error) {
    console.error('Failed to load analytics configuration:', error);
    return null;
  }
};

// Default config for fallback
export const defaultAnalyticsConfig: AnalyticsConfig = {
  googleAnalytics: {
    enabled: false,
    measurementId: '',
    config: {
      send_page_view: true,
      anonymize_ip: true,
      cookie_flags: 'SameSite=None;Secure'
    },
    debug: false
  }
};
